import { useSelector } from 'react-redux'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { Content } from './Content'

export const Highlight = ({ setIsShowPreferenceSetting }) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  return (
    AUTHORIZATION_API.companyAnalysis.highLightBox[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW && (
      <Content setIsShowPreferenceSetting={setIsShowPreferenceSetting} />
    )
  )
}
